module.exports = __webpack_public_path__ + "static/media/Tyrion Lannister 3.1b699050.jpg";